module.exports = __webpack_public_path__ + "media/images/client-22-8be1a1faac4a8abe2ec8caed6b64909f.png";